import { Card, Icon, Typography } from '@globalmed/atlas-ui';
import styles from './FormBuilderFieldsEmpty.module.css';

type TProps = {
  title: string;
  description: string;
};

/**
 * Empty state component shown when form builder has no fields
 * @param props - Component props
 * @param props.title - Title text for empty state
 * @param props.description - Description text for empty state
 * @returns Form builder empty state component
 */
export const FormBuilderFieldsEmpty = ({ title, description }: TProps) => {
  return (
    <Card variant="white" padding="48px" className={styles.emptyCard}>
      <Icon name="Control" size="64px" color="var(--colors-gray400)" />
      <div className={styles.textWrapper}>
        <Typography
          fontSize="18px"
          fontWeight={600}
          sx={{ textAlign: 'center' }}
        >
          {title}
        </Typography>
        <Typography color="var(--colors-gray600)" sx={{ textAlign: 'center' }}>
          {description}
        </Typography>
      </div>
    </Card>
  );
};
